export default __webpack_public_path__ + "static/media/P316.2.eb2f49f2.mp3";